import { OrganizationTraits } from '@neptune/shared/core-organizations-domain';

export const hasCapabilitiesToManageUserSeats = (traits: OrganizationTraits): boolean => {
  return !!traits.usersLimit?.quotaEditable;
};

export const getUserSeatsLimit = (traits: OrganizationTraits) => {
  return traits.usersLimit?.maxQuota;
};

export const getUserSeatsQuota = (traits: OrganizationTraits) => {
  return traits.usersLimit?.currentQuota;
};
